var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('zueri9-clients',{attrs:{"absence":_vm.absence}}),_c('zueri9-reason',{attrs:{"absence":_vm.absence}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }